/**
 * Единственный источник порогов оценки. Панель мапит band на Tailwind-класс,
 * печатный отчёт — на hex. До появления этого модуля пороги были в двух
 * местах и разошлись: панель 80/60/40, печать 70/50.
 */
export type ScoreBand = 'excellent' | 'good' | 'fair' | 'poor';

export function scoreBand(score: number): ScoreBand {
  if (score >= 80) return 'excellent';
  if (score >= 60) return 'good';
  if (score >= 40) return 'fair';
  return 'poor';
}
